"use client";

import React, { ReactNode } from "react";
import { cn } from "utils/utils";

export interface RadioOption<T> {
  value: T;
  label: string | ReactNode;
  key?: string;
  icon?: ReactNode;
}

interface RadioGroupProps<T> {
  options: RadioOption<T>[];
  value: T;
  onChange: (value: T) => void;
  name: string;
  orientation?: "vertical" | "horizontal";
  disabled?: boolean;
  className?: string;
  optionClassName?: string;
  selectedClassName?: string;
  unselectedClassName?: string;
}

export function RadioGroup<T>({
  options,
  value,
  onChange,
  name,
  orientation = "horizontal",
  disabled = false,
  className = "",
  optionClassName = "",
  selectedClassName = "border-primary/50 bg-primary/5 text-primary",
  unselectedClassName = "border-base-content/20 bg-transparent",
}: RadioGroupProps<T>) {
  return (
    <div
      className={cn(
        "join w-full",
        orientation === "vertical" ? "join-vertical" : "",
        className
      )}
    >
      {options.map((option, index) => (
        <label
          key={option.key || `${name}-option-${index}`}
          className={cn(
            "join-item flex cursor-pointer select-none items-center justify-center gap-2 border p-[0.55rem] text-sm transition-all",
            disabled && "cursor-not-allowed opacity-50",
            optionClassName,
            value === option.value ? selectedClassName : unselectedClassName
          )}
        >
          <input
            type="radio"
            name={name}
            className="hidden"
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
          />
          {option.icon}
          {option.label}
        </label>
      ))}
    </div>
  );
}
